const UPDATE_REGISTRATION_STATUS = "registration:UPDATE_REGISTRATION_STATUS";

export const actionTypes = {
  UPDATE_REGISTRATION_STATUS
};

const updateRegistrationStatus = data => {
  return {
    type: UPDATE_REGISTRATION_STATUS,
    data
  };
};

export default {
  updateRegistrationStatus
};
